import { useSearchParams, useNavigate } from "react-router-dom";
import { useCallback, useMemo } from "react";
import { combineQueryParams, extractQueryParams } from "src/utils/query";

function useQueryParams(defaultValue) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paramString = searchParams.toString();

  const value = useMemo(() => {
    const extractedValue = extractQueryParams(paramString, defaultValue);
    return {
      ...defaultValue,
      ...extractedValue,
    };
  }, [paramString, defaultValue]);

  const setValue = useCallback(
    (newValue) => {
      const params = combineQueryParams(paramString, newValue);
      navigate(`?${params}`);
    },
    [navigate, paramString],
  );

  return [value, setValue];
}

export default useQueryParams;
